module.exports = __webpack_public_path__ + "static/media/zoe-lee.a385fabb.jpg";